import React from 'react'

import { useMinicrudsPermission } from '../../../utils/helpers/minicrudsPermission'
import { useOpenEditMinicrudModal } from '../../../utils/routes/modals/modalsActions'
import { useRouteParam } from '../../../utils/routes/helpers/useParam'
import FixedRoundButton from '../../../components/actions/FixedRoundButton'

const AddNewButton = () => {
  const entity = useRouteParam('entity')
  const hasAddPermission = useMinicrudsPermission(entity)
  const openModal = useOpenEditMinicrudModal()

  if (!hasAddPermission) return false

  return <FixedRoundButton onClick={() => openModal({ entity })} />
}

export default AddNewButton
